import React from 'react'

const Reviews = () => {
  return (
    <div>
      hwllo
      
    </div>
  )
}

export default Reviews
